// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"70":"a528a864","205":"835f6a38","484":"a0ac5b7b","551":"9deb60aa","672":"918b3da2","757":"4fc9917c","842":"0006ed0a","869":"59cb8f13","974":"ef3ddcef"}[chunkId] + ".chunk.js";
};